module.exports = __webpack_public_path__ + "static/media/duffey-5.fd85a26b.jpg";